import { render, staticRenderFns } from "./LandingHero.vue?vue&type=template&id=eefdfb82&scoped=true&"
import script from "./LandingHero.vue?vue&type=script&lang=ts&"
export * from "./LandingHero.vue?vue&type=script&lang=ts&"
import style0 from "./LandingHero.vue?vue&type=style&index=0&id=eefdfb82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefdfb82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('eefdfb82', component.options)
    } else {
      api.reload('eefdfb82', component.options)
    }
    module.hot.accept("./LandingHero.vue?vue&type=template&id=eefdfb82&scoped=true&", function () {
      api.rerender('eefdfb82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/classrooms/components/landing/LandingHero.vue"
export default component.exports